var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(((_vm.layout + "Layout") in _vm.$options.components))?_c((_vm.layout + "Layout"),{tag:"component"},[(_vm.hasAccess)?[_c('router-view')]:[_c('Login')]],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }